import {Component, Injector, OnInit} from '@angular/core';
import {MobileBasePage} from 'src/app/core/base/mobile-base-page';
import {NavParams} from '@ionic/angular';


@Component({
    selector: 'app-language_choice',
    templateUrl: './language_choice.html',
    styleUrls: ['./language_choice.scss']
})
export class LanguageChoice extends MobileBasePage implements OnInit {
    inputs: any;
    lang: string;
    callBack: any;

    constructor(private injector: Injector, public navParams: NavParams) {
        super(injector);
        this.inputs = this.navParams.get('inputs');
        this.lang = this.navParams.get('lang');
        this.callBack = this.navParams.get('callBack');
        console.log(this.inputs);
    }

    ngOnInit() {
    }

    clickedLanguage(value) {
        this.popoverController.dismiss();
        if (value === this.lang) return;
        this.t.use(value).subscribe(data => {
            this.configService.setLocale(value);
            if (value === 'zh')
                document.documentElement.setAttribute('lang', 'zh-Hant');
            else if (value === 'zh-cn') {
                document.documentElement.setAttribute('lang', 'zh-Hans');
            } else {
                document.documentElement.setAttribute('lang', value);
            }
            this.callBack(value);
        });
    }
}

